import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
export class SelectorViewModel extends BaseViewModel {
  constructor() {
    super();
  }

  getSites = async () => {
    var siteResponse = await this.getSiteListByCodeTag();
    if (Format.isNotNull(siteResponse.siteList)) {
      this.updateState("siteList", siteResponse.siteList);
      var siteArray = UIMap.getDropdownOptions(siteResponse.siteList);
      this.updateState("siteOptions", siteArray);
      this.logger.info(siteResponse.siteList);
    } else {
      this.showError("Site", CrudlStatus.LIST);
    }
  };
  getSitesByClientId = async clientId => {
    var siteResponse = await this.getSiteListByClientId(clientId);
    if (Format.isNotNull(siteResponse.siteList)) {
      this.updateState("siteList", siteResponse.siteList);
      var siteArray = UIMap.getDropdownOptions(siteResponse.siteList);
      this.updateState("siteOptions", siteArray);
      this.logger.info(siteResponse.siteList);
    } else {
      this.showError("Site", CrudlStatus.LIST);
    }
  };
  getBuildings = async id => {
    var buildingResponse = await this.getBuildingListBySiteId(id);
    if (Format.isNotNull(buildingResponse.buildingList)) {
      this.updateState("buildingList", buildingResponse.buildingList);
      var buildingArray = UIMap.getDropdownOptions(
        buildingResponse.buildingList
      );
      this.updateState("buildingOptions", buildingArray);
      this.logger.info(buildingResponse.buildingList);
    } else {
      this.showError("Building", CrudlStatus.LIST);
    }
  };
  getLocations = async (id, clientId) => {
    var locationResponse = await this.getLocationListByBuildingId(id, clientId);
    if (Format.isNotNull(locationResponse.locationList)) {
      this.updateState("locationList", locationResponse.locationList);
      var locationArray = UIMap.getDropdownOptions(
        locationResponse.locationList
      );
      this.updateState("locationOptions", locationArray);
      this.logger.info(locationResponse.locationList);
    } else {
      this.showError("Location", CrudlStatus.LIST);
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Sites/SelectorViewModel.js